export const interpolateMicrocopy = (
  microcopy: string,
  variables: Record<string, string>,
) =>
  Object.entries(variables).reduce(
    (_microcopy, [variableName, variableValue]) => {
      const variableNameRegex = new RegExp(`##${variableName}##`, 'g');
      return _microcopy.replace(variableNameRegex, variableValue);
    },
    microcopy,
  );
